import type { FaireProductEntity } from "../../entity_types/product";

export const p_pp326pxpww: FaireProductEntity = {
  token: "p_pp326pxpww",
  type: "product",
  name: "Molasses Canelé",
  brandToken: "b_3mzwb88s7h",
  brandName: "Waxing Moon",
  imageUrl:
    "https://cdn.faire.com/fastly/917085cae99536ba13bc19a6d2590efe6d51c9c5d48b15a44a15535ed8431d65.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/115c52aa35c992dfc312b183703011b0688f2664a899b8fac94c68458172b902.jpeg",
    "https://cdn.faire.com/fastly/6a050f2f486866d48149f816f14f97f6acbf2cd5370fa27a7d2812a66c01b82a.jpeg",
    "https://cdn.faire.com/fastly/c09ff69a79d6c7b9e185c565cabe05090273bd4eb1a9387e3b8db48bf4fbd361.jpeg",
  ],
  priceDollars: 3.3,
  description:
    "These canelés are made with our molasses beeswax which is older hive wax which has a darker tone and a robust sweetness with slightly bitter note but still only beeswax.\n\nThe canelé originated in the Bordeaux region of France and is traditionally baked in a copper fluted mold that has been brushed with beeswax. From that piece of information, and its connection to both beeswax + pastry, we created our own canelé. \n\nCanelé \nDimensions: height 4.5 cm x 5 cm at widest point\nBurn Time: 10 hours",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:58.947Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
